import { APICore } from "../apiCore";
import { getGuildApiParams } from "../../Guild/guildUtils";

const api = new APICore();

function search(term, guild = getGuildApiParams()?.guild) {
    return api.update('/search', { term, guild });
}

export { search };
